import { Avatar, Box, Tooltip } from '@mui/material';
import React from 'react';
import { useRecordContext } from 'react-admin';

export const LeadersAvatar = () => {
  const record = useRecordContext();
  if (!record || !record.leaders) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {record.leaders.map(leader => (
        <Tooltip key={leader.id} title={leader.username} arrow>
          {leader.avatar ? (
            <Avatar
              src={leader.avatar}
              alt={leader.username}
              sx={{ width: 40, height: 40 }}
            />
          ) : (
            <Avatar alt={leader.username} sx={{ width: 40, height: 40 }} />
          )}
        </Tooltip>
      ))}
    </Box>
  );
};
